import { ComponentProps, useCallback, useState } from 'react';
import { Modal as RSModal } from 'reactstrap';
import { Content } from 'src/contexts/ContentContext';
import { GenericDialog } from 'src/core/interim/dialogs/GenericDialog';
import { Radio, RadioGroup, Stack } from 'src/core/ui';
import { Button } from 'src/core/ui';
import { useAutoPricingResultStateActions } from 'src/hooks/useAutoPricingResultStateActions';
import { ContentId } from 'src/utils/constants/contentId';
import { VelocityCircuitBreakerSuppressionType } from 'src/WebApiController';

export type SuppressCircuitBreakerDialogProps = ComponentProps<
  typeof RSModal
> & {
  listingId: number;
  onCancelClick: () => void;
};

export const SuppressCircuitBreakerDialog = ({
  listingId,
  onCancelClick,
  ...rest
}: SuppressCircuitBreakerDialogProps) => {
  const [suppressionType, setSuppressionType] =
    useState<VelocityCircuitBreakerSuppressionType>(
      VelocityCircuitBreakerSuppressionType.Reset
    );

  const { onSubmits } = useAutoPricingResultStateActions();

  return (
    <>
      <GenericDialog
        {...rest}
        isOpen={rest.isOpen}
        size="m"
        header={<Content id={ContentId.PriceDropVelocitySettings} />}
        footer={
          <>
            <Button variant="text" onClick={onCancelClick}>
              <Content id={ContentId.Cancel} />
            </Button>
            <Button
              onClick={() => {
                onSubmits.suppressCircuitBreaker({
                  listingId,
                  suppressionType,
                });

                onCancelClick();
              }}
            >
              <Content id={ContentId.Save} />
            </Button>
          </>
        }
      >
        <RadioGroup
          value={suppressionType}
          defaultValue={VelocityCircuitBreakerSuppressionType.Reset}
          onValueChange={(v) =>
            setSuppressionType(v as VelocityCircuitBreakerSuppressionType)
          }
        >
          <Stack direction="column" gap="m">
            <Radio
              value={VelocityCircuitBreakerSuppressionType.Reset}
              label={<Content id={ContentId.ResetVelocity} />}
            />
            <Radio
              value={VelocityCircuitBreakerSuppressionType.Permanent}
              label={<Content id={ContentId.IgnoreVelocity} />}
            />
          </Stack>
        </RadioGroup>
      </GenericDialog>
    </>
  );
};
